import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

const INDENT_PER_LEVEL = 16;

export const StyledCategorySection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: 1rem;
  border: 1px solid ${COLORS.GREY};
  border-radius: 0.5rem;
  background-color: ${COLORS.GRAY_LIGHT};
`;

export const StyledTreeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`;

export const StyledTreeHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 8rem;
  gap: 1rem;
  align-items: center;
  padding: 0 1rem 0.75rem;
  ${pickThemeFontStyles('14', '22', 'SEMI_BOLD')};
  color: ${COLORS.CHARCOAL};

  > span:last-child {
    width: 8rem;
    text-align: left;
    justify-self: end;
  }
`;

export const StyledCategoryRow = styled.div<{ $level: number; $isSelected: boolean }>`
  display: grid;
  grid-template-columns: 1fr 8rem;
  gap: 1rem;
  align-items: center;
  width: 100%;
  margin-top: ${({ $level }) => ($level > 0 ? '0.5rem' : 0)};
  padding: 0.35rem 0.5rem 0.35rem ${({ $level }) => `${$level * INDENT_PER_LEVEL}px`};
  border-radius: 0.375rem;
  color: ${COLORS.BLACK};
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: ${COLORS.BRIGHT_GRAY};
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background: ${COLORS.YELLOW_PRIMARY};

    &:hover {
      background: ${COLORS.YELLOW_PRIMARY};
    }
  `}
`;

export const StyledCategoryTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  min-width: 0;
`;

export const StyledChevronWrapper = styled.div`
  width: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`;

export const StyledCategoryTitle = styled.div<{ $isFirstLevel: boolean }>`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  font-weight: ${({ $isFirstLevel }) => ($isFirstLevel ? 600 : 400)};
  text-transform: ${({ $isFirstLevel }) => ($isFirstLevel ? 'uppercase' : 'none')};
`;

export const StyledCommissionInputWrap = styled.div`
  width: 8rem;
  max-width: 100%;
  justify-self: end;

  .ant-input-number {
    width: 100%;
    min-height: 2.25rem;
    background: ${COLORS.WHITE} !important;
    border: 1px solid ${COLORS.SOFT_GRAY} !important;
    border-radius: 0.25rem;
    box-shadow: none;

    &:hover,
    &.ant-input-number-focused {
      border-color: ${COLORS.YELLOW_PRIMARY} !important;
    }
  }

  .ant-input-number-input {
    text-align: center;
    ${pickThemeFontStyles('14', '22', 'SEMI_BOLD')};
    color: ${COLORS.BLACK_PRIMARY};
  }

  .ant-input-number-group-addon {
    ${pickThemeFontStyles('14', '22', 'SEMI_BOLD')};
    color: ${COLORS.CHARCOAL};
    background: ${COLORS.WHITE};
    border-color: ${COLORS.SOFT_GRAY};
  }
`;

export const StyledListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const StyledTrendValue = styled.span<{ $direction: 'up' | 'down' | 'equal' }>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${({ $direction }) => {
    switch ($direction) {
      case 'up':
        return COLORS.GREEN;
      case 'down':
        return COLORS.RED;
      default:
        return COLORS.BLACK_PRIMARY;
    }
  }};

  svg {
    width: 0.75rem;
    height: 0.75rem;
    flex-shrink: 0;
  }
`;

export const StyledHistoryFiltersRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
`;

export const StyledHistoryFilterControl = styled.div`
  min-width: 12rem;

  .ant-select,
  .ant-picker {
    width: 100%;
  }
`;

export const StyledHistoryEmpty = styled.p`
  margin: 0;
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.IRON_GRAY};
`;

export const StyledHistoryFooterNote = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-top: 1.5rem;
  padding: 1rem 1.25rem;
  border-radius: 0.5rem;
  background: ${COLORS.GRAY_LIGHT};
  border: 1px solid ${COLORS.LIGHT_GRAY};
`;

export const StyledHistoryFooterIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 0.125rem;
  color: ${COLORS.BLUE_PRIMARY};
  font-size: 1.125rem;
`;

export const StyledHistoryFooterText = styled.div`
  ${pickThemeFontStyles('14', '22', 'NORMAL')};
  color: ${COLORS.CHARCOAL};
  white-space: pre-line;
`;

export const StyledHistoryListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
